//@ts-check
import { apiClient } from './client.js';

/**
 * @typedef {import('@/lib/permissions.js').AuthUser} AuthUser
 */

/**
 * @param {{ email: string, password: string }} body
 * @returns {Promise<{ accessToken: string, user: AuthUser }>}
 */
export async function login(body) {
  const { data } = await apiClient.post('/auth/login', { ...body, client: 'web' });
  return data;
}

/**
 * @returns {Promise<{ accessToken: string, user: AuthUser }>}
 */
export async function refreshSession() {
  const { data } = await apiClient.post('/auth/refresh', {});
  return data;
}

/**
 * @returns {Promise<void>}
 */
export async function logout() {
  await apiClient.post('/auth/logout', {});
}

/**
 * @returns {Promise<{ user: AuthUser }>}
 */
export async function fetchMe() {
  const { data } = await apiClient.get('/auth/me');
  return data;
}
